import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    subheader: {
      backgroundColor: theme.palette.common.lightBlue,
      padding: '12px 32px 24px',
    },
    bordered: {
      borderRadius: '100%',
      borderColor: theme.palette.common.white,
      borderWidth: 2,
      borderStyle: 'solid',
    },
    online: {
      color: theme.palette.success.main,
    },
    reserved: {
      color: theme.palette.primary.main,
    },
    late: {
      color: theme.palette.error.main,
    },
    SCHEDULEDELIVERY: {
      color: theme.palette.primary.main,
      fontWeight: 500,
    },
    MARKASDELIVERED: {
      color: theme.palette.primary.main,
      fontWeight: 500,
    },
    DELIVERY: {
      color: theme.palette.primary.main,
      fontWeight: 500,
    },
    NEEDSAPPROVAL: {
      color: theme.palette.success.main,
      fontWeight: 500,
    },
    MARKASRETURNED: {
      color: theme.palette.warning.main,
      fontWeight: 500,
    },
    link: {
      fontSize: 12,
      fontWeight: 500,
      color: theme.palette.primary.main,
      '&:visited': {
        color: theme.palette.primary.main,
      },
      '&:hover': {
        fontWeight: 500,
      },
    },
  };
});

const CardStyles = makeStyles({
  root: {
    padding: 0,
    paddingBottom: '0 !important',
  },
});

export { useStyles, CardStyles };
